export default __webpack_public_path__ + "static/media/address_blue.2b478150.svg";